/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from "react"
import { connect } from "react-redux"
import { Element, Route } from "trux"
import { ForceLogin } from "../ForceLogin"
import { SaveClip } from "./SaveClip"
import { AboutTraceID } from "../AboutTraceID"
import { JumpToTraceIdDialog } from "./JumpToClipDialog"
import { NoFullGameDialog } from "./NoFullGameDialog"
import "./save.css"

class SaveToProfileComp extends Component {
    render() {
        let clipType = null
        if (this.props.clip && this.props.clip.meta) {
            clipType = this.props.clip.meta.type
        }

        return (
            <Element trkContext="Add to Trace ID" className="SaveToProfile">
                {clipType !== "FullGameVideo" && !this.props.forceLogin && (
                    <Route
                        path="/:team_name/games/:game_id/:playlist_id/:event_number/save/profile"
                        render={(props) => (
                            <SaveClip
                                {...props}
                                relations={this.props.relations}
                            />
                        )}
                    />
                )}

                {clipType === "FullGameVideo" && !this.props.forceLogin && (
                    <Route
                        path="/:team_name/games/:game_id/:playlist_id/:event_number/save/profile"
                        component={NoFullGameDialog}
                    />
                )}

                {this.props.forceLogin && (
                    <Route
                        path="/:team_name/games/:game_id/:playlist_id/:event_number/save/profile"
                        render={(props) => {
                            return (
                                <ForceLogin
                                    {...props}
                                    onClose={this.props.dismissLogin}
                                />
                            )
                        }}
                    />
                )}

                <Route
                    path="/:team_name/games/:game_id/:playlist_id/:event_number/jump/profile/confirm"
                    component={JumpToTraceIdDialog}
                />

                <Route
                    path="/:team_name/games/:game_id/:playlist_id/:event_number/about/traceid"
                    component={AboutTraceID}
                />
            </Element>
        )
    }
}

const mapStateToProps = (state, pageProps) => {
    let show = state.user.complete && !state.isLoggedIn

    return {
        forceLogin: show,
        clip: state.video.value.source,
        rev: new Date().getTime(),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const SaveToProfile = connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveToProfileComp)

export default SaveToProfile
